import { useState, useCallback } from 'react';
import { DownloadCsvProps, downloadCsv, handleDownloadCsvError } from '../utility/csvUtils';
import { AxiosError } from 'axios';

export const useDownloadCsv = <FilterParam, SortParam>({ params, controller }: DownloadCsvProps<FilterParam, SortParam>) => {
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);

  const handleDownloadCsv = useCallback(() => {
    (async () => {
      setIsDownloadingCsv(true);

      try {
        await downloadCsv({
          params,
          controller,
        });
      } catch (err) {
        handleDownloadCsvError(err as AxiosError);
      } finally {
        setIsDownloadingCsv(false);
      }
    })();
  }, [params, controller, setIsDownloadingCsv]);

  return { isDownloadingCsv, handleDownloadCsv };
};
